import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Divider,
  IconButton,
  Typography,
} from "@material-ui/core";
import { ArrowDropDown, ArrowRight } from "@material-ui/icons";
import Skeleton from "@material-ui/lab/Skeleton";
import isEmpty from "lodash/isEmpty";
import { TFunction } from "next-i18next";
import React, { useContext, useState } from "react";
import ButtonMin from "../../public/img/ButtonMin";
import ButtonPlus from "../../public/img/ButtonPlus";
import ImgIcon from "../../public/img/IconImg";
import PeopleIcon from "../../public/img/PeopleIcon";
import useStyles from "../../styles/components/CardRoom";
import { CartRoomContext } from "../context/CartRoom";
import { RoomDto } from "../libs/rooms";
import numberSeparator from "../utils/numberSeparator";
import DialogImageRoomRate from "./DialogImageRoomRate";

type Props = {
  skeleton?: boolean;
  isCanAdd: number;
  quantity: number;
  MinOrderQty: any;
  PlusOrderQty: any;
  data: RoomDto;
  readonly t: TFunction;
};

const CardRoom = (props: Props) => {
  const classes = useStyles(props);
  const { t, skeleton, isCanAdd, quantity, MinOrderQty, PlusOrderQty, data } =
    props;
  const { cart } = useContext(CartRoomContext);
  const [expanded, setExpanded] = useState({
    expand: false,
    code: "",
  });
  const [showDialogImageRoomRate, setShowDialogImageRoomRate] = useState(false);

  return (
    <>
      {skeleton ? (
        <SkeletonLoading />
      ) : (
        <>
          <div className={classes.root}>
            <div className={classes.roomTypeNameWrapper}>
              <Typography className={classes.roomTypeName}>
                {data.roomName}
              </Typography>
            </div>
            <div className={classes.imageWrapper}>
              <img
                src={
                  !isEmpty(data.images[0])
                    ? data.images[0]
                    : "/img/placeholder-image-room.svg"
                }
                alt="placeholder-image-room"
                className={classes.image}
                onClick={() => {
                  if (data.images.length) setShowDialogImageRoomRate(true);
                }}
              />
              <div className={classes.imageIndex}>
                <ImgIcon />
                <Typography
                  variant="caption"
                  style={{ color: "#ffffff", paddingLeft: 5 }}
                >
                  {data.images?.length ? `1/${data.images?.length}` : "0/0"}
                </Typography>
              </div>
            </div>
            {data.ratePlans.map((ratePlan, index) => {
              const selectedRoomTypeIndex = cart.findIndex(
                (val) => val.roomId === data.roomId
              );
              const selectedRoomType = cart[selectedRoomTypeIndex];
              const currentRatePlanIndex =
                selectedRoomType?.ratePlans?.findIndex(
                  (val) => val.code === ratePlan.code
                );
              const currentRatePlan =
                selectedRoomType.ratePlans[currentRatePlanIndex];
              return (
                <>
                  <Accordion
                    expanded={
                      expanded.expand && expanded.code === ratePlan.code
                    }
                    onChange={(_event, expanded) =>
                      setExpanded({ expand: expanded, code: ratePlan.code })
                    }
                  >
                    <AccordionSummary
                      aria-label="Expand"
                      aria-controls="additional-actions2-content"
                      id="additional-actions2-header"
                      className={classes.accordionSummary}
                    >
                      <div className={classes.contentWrapper}>
                        <div className={classes.headWrapper}>
                          {expanded.expand &&
                          expanded.code === ratePlan.code ? (
                            <ArrowDropDown />
                          ) : (
                            <ArrowRight />
                          )}
                          <Typography
                            variant="caption"
                            className={classes.roomRatePlanName}
                          >
                            {ratePlan.name}
                          </Typography>
                        </div>
                        <div className={classes.priceWrapper}>
                          <div>
                            <div className={classes.breakfastInformation}>
                              {ratePlan.breakfast ? (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <img
                                    src="/img/include-breakfast.svg"
                                    alt="include-breakfast"
                                  />
                                  <Typography
                                    className={classes.price}
                                    style={{
                                      color: "#3682E6",
                                      marginLeft: 5,
                                      fontSize: 12,
                                    }}
                                  >
                                    {t("breakfast-included")}
                                  </Typography>
                                </div>
                              ) : (
                                <div
                                  style={{
                                    display: "flex",
                                    alignItems: "center",
                                  }}
                                >
                                  <img
                                    src="/img/exclude-breakfast.svg"
                                    alt="exclude-breakfast"
                                  />
                                  <Typography
                                    className={classes.price}
                                    style={{
                                      color: "#A0A4A8",
                                      marginLeft: 5,
                                      fontSize: 12,
                                    }}
                                  >
                                    {t("breakfast-excluded")}
                                  </Typography>
                                </div>
                              )}
                              <Divider orientation="vertical" />
                              <div className={classes.capacity}>
                                <PeopleIcon />
                                <Typography
                                  style={{
                                    paddingLeft: 5,
                                    fontSize: 12,
                                    color: "#52575C",
                                  }}
                                >
                                  {data.maxGuest +
                                    " " +
                                    (data.maxGuest > 1
                                      ? t("guests")
                                      : t("guest"))}
                                </Typography>
                              </div>
                            </div>
                            <Typography className={classes.price}>
                              Rp{numberSeparator(ratePlan.price)}/{t("room")} (
                              {data.night +
                                " " +
                                (data.night > 1 ? t("nights") : t("night"))}
                              )
                            </Typography>
                          </div>
                          <div>
                            {currentRatePlan.order === 0 ? (
                              <Button
                                disabled={
                                  !isCanAdd || data.qty === quantity
                                    ? true
                                    : false
                                }
                                variant="contained"
                                className={classes.button}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  PlusOrderQty(
                                    data.roomId,
                                    ratePlan.code,
                                    data
                                  );
                                }}
                              >
                                {t("card-room-order")}
                              </Button>
                            ) : (
                              <div className={classes.plusMinusWrapper}>
                                <IconButton
                                  style={{
                                    cursor: "pointer",
                                    margin: 0,
                                    padding: 0,
                                  }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    MinOrderQty(data.roomId, ratePlan.code);
                                  }}
                                >
                                  <ButtonMin />
                                </IconButton>
                                <Typography className={classes.quantity}>
                                  {currentRatePlan.order}
                                </Typography>
                                <IconButton
                                  style={{
                                    cursor: "pointer",
                                    margin: 0,
                                    padding: 0,
                                  }}
                                  onClick={(e) => {
                                    data.qty !== quantity &&
                                      e.stopPropagation();
                                    PlusOrderQty(
                                      data.roomId,
                                      ratePlan.code,
                                      data
                                    );
                                  }}
                                >
                                  <ButtonPlus
                                    color={
                                      data.qty === quantity
                                        ? "rgba(0, 0, 0, 0.12)"
                                        : "#9e007e"
                                    }
                                  />
                                </IconButton>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </AccordionSummary>
                    <AccordionDetails className={classes.accordionDetails}>
                      <Typography style={{ fontSize: 12 }}>
                        {ratePlan?.description || "-"}
                      </Typography>
                    </AccordionDetails>
                  </Accordion>
                  <div key={index}>
                    {index + 1 !== data.ratePlans.length && (
                      <Divider
                        style={{
                          backgroundColor: "#C4C4C4",
                        }}
                      />
                    )}
                  </div>
                </>
              );
            })}
            <DialogImageRoomRate
              onClose={() => setShowDialogImageRoomRate(false)}
              images={data.images}
              open={showDialogImageRoomRate}
            />
          </div>
        </>
      )}
    </>
  );
};

export default CardRoom;

function SkeletonLoading(props) {
  const classes = useStyles(props);

  return (
    <>
      <div className={classes.root}>
        <Skeleton
          height={106}
          width={114}
          variant="rect"
          style={{ borderRadius: 10 }}
        />
        <div className={classes.contentWrapper}>
          <div className={classes.headWrapper}>
            <Skeleton variant="text" width={88} />
            <div className={classes.capacity}>
              <Skeleton variant="text" width={20} />
            </div>
          </div>
          <div className={classes.priceWrapper}>
            <div>
              <Skeleton variant="text" width={130} />
              <Skeleton variant="text" width={100} />
            </div>
            <div>
              <Skeleton
                height={36}
                width={67}
                variant="rect"
                style={{ borderRadius: 5 }}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
